import React from "react";
import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import { EditTextFieldDialog } from "../core/EditTextFieldDialog";

const Display = ({ title, value }) => (
  <ListItemText
    primary={title}
    secondary={value || "click to edit"}
    sx={{ maxWidth: "66ch", whiteSpace: "pre-wrap" }}
  />
);

/**
 * @param {object} props
 * @param {string} props.title
 * @param {string|number} props.text
 * @param {string} props.helperText
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.singleline]
 * @param {(text: (string|number)) => void} props.onSave
 */
export const EditableListItem = ({ title, text, helperText, onSave, disabled, singleline = false }) => {
  return (
    <Stack direction="row" display="flex" justifyContent="flex-end">
      {disabled ? (
        <Display title={title} value={text} />
      ) : (
        <Box>
          <EditTextFieldDialog
            onSave={onSave}
            title={title}
            initialValue={text}
            isBusy={false}
            helperText={helperText}
            multiline={!singleline}
            onEnterDisabled={!singleline}
          >
            <Display title={title} value={text} />
          </EditTextFieldDialog>
        </Box>
      )}
    </Stack>
  );
};
